import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { EventTypeEnum } from "shared/types";

import { DETAILS_RELATED_EVENTS_ID } from "pages/Dashboard/components/constants";
import RelatedEvent from "pages/Dashboard/components/EventDetails/RelatedEvent";
import { LandingPageEventType } from "pages/Dashboard/types";
import { LandingPageViewConfig } from "pages/shared/Dashboard/types";

import LinkButton from "features/ui/LinkButton";

interface RelatedEventsAndSmartGroupsProps {
  event: LandingPageEventType;
  config: LandingPageViewConfig;
  className?: string;
}

const RelatedEventsAndSmartGroups = ({
  event,
  config,
  className,
}: RelatedEventsAndSmartGroupsProps) => {
  const { t } = useTranslation();
  const showRelatedEvents =
    config.eventDetails?.relatedEvents &&
    config.eventDetails?.relatedEvents.length > 0;
  const showSmartGroups = event.smartGroups && event.smartGroups.length > 0;

  if (!showRelatedEvents && !showSmartGroups) {
    return null;
  }

  const isSignalEvent = config.eventType === EventTypeEnum.SIGNAL_EVENT;

  return (
    <div
      className={classNames(
        "flex flex-row",
        {
          "border border-purple-200 rounded-lg": isSignalEvent,
        },
        className
      )}
    >
      {showRelatedEvents && (
        <div
          className={classNames("flex-1", {
            "border-r border-purple-100": showSmartGroups,
          })}
        >
          <div className="flex flex-col gap-2">
            <div
              className={classNames("bg-purple-100 px-2.5 py-1.5", {
                "rounded-t-lg": isSignalEvent,
              })}
            >
              <LinkButton
                className="font-bold text-left"
                data-testid="qv-related-events-button"
                onClick={() => {
                  const element = document.getElementById(
                    DETAILS_RELATED_EVENTS_ID
                  );
                  element?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                {t("schema:dashboard.related_events")}
              </LinkButton>
            </div>
            <div className="flex flex-col items-start gap-1 px-2.5 py-0.5">
              {config.eventDetails?.relatedEvents.map((relatedEvent, i) => (
                <RelatedEvent
                  key={relatedEvent.title + `_${i}`}
                  event={event}
                  relatedEvent={relatedEvent}
                  index={i}
                />
              ))}
            </div>
          </div>
        </div>
      )}
      {showSmartGroups && (
        <div className="flex-1">
          <div className="flex flex-col gap-2">
            <div
              className={classNames("bg-purple-100 px-2.5 py-1.5 font-bold", {
                "rounded-t-lg": isSignalEvent,
              })}
            >
              {t("schema:dashboard.smart_groups_title")}
            </div>
            <div className="flex flex-col gap-1 px-2.5 py-1.5">
              {event.smartGroups?.map(({ ID, name }) => (
                <div key={ID}>{name}</div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RelatedEventsAndSmartGroups;
